<template>
  <div>
    <div class="grid gap-1 md:gap-2 grid-cols-2 md:grid-cols-6">
      <div v-for="page in pages" :key="page.id" class="bg-white border inline-block align-middle relative">
        <router-link :to="{name: 'splash_page_details', params: {pageId: page.id}}">
          <img :src="page.screenshot" class="inline-block align-middle h-32 md:h-48 w-full">
        </router-link>
        <div class="p-2 ">
          <router-link :to="{name: 'splash_page_details', params: {pageId: page.id}}"
                       class="tab tab-explore block font-semibold mt-1"> {{ page.name }}
          </router-link>
          <div class="h-10 overflow-hidden">
            <small class="">{{ page.description }}</small>
          </div>
          <div class="float-right mb-2 relative">
            <div v-if="page.type == null" class="flex mt-2 bottom-0">
              <router-link  v-if="$store.getters.can('edit_splash_pages')"
                  class="border rounded text-xs mr-2 border-teal-500 text-teal-500 p-1 hover:bg-teal-500 hover:text-white"
                  :to="{name: 'splash_page_details', params: {pageId: page.id}}">Set up
              </router-link>

              <button @click="deletePage(page)"  v-if="$store.getters.can('delete_splash_pages')"
                      class="border hidden md:block rounded text-xs border-red-500 text-red-500 p-1 hover:bg-red-500 hover:text-white">
                Delete
              </button>
            </div>
            <div v-else class="flex mt-2 bottom-0">
              <router-link v-if="$store.getters.can('create_splash_pages')"
                           class="border rounded text-xs mr-2 border-teal-500 text-teal-500 p-1 hover:bg-teal-500 hover:text-white"
                           :to="{name: 'splash_page_details', params: {pageId: page.id}}">Details
              </router-link>

              <button @click="publishPage(page)" v-if="!page.published &&  $store.getters.can('publish_splash_pages')"
                      class="border rounded text-xs mr-2 border-blue-500 text-blue-500 p-1 hover:bg-blue-500 hover:text-white">
                Publish
              </button>
              <a v-else target="_blank"
                 class="border rounded text-xs mr-2 border-blue-500 text-blue-500 p-1 hover:bg-blue-500 hover:text-white"
                 :href="page.page_url">View page</a>
              <button @click="deletePage(page)" v-if="$store.getters.can('delete_splash_pages')"
                      class="border hidden md:block rounded text-xs border-red-500 text-red-500 p-1 hover:bg-red-500 hover:text-white">
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SplashPageService from "../services/splashPage.service";

export default {
  name: "SplashPagesComponent",
  props: {
    adminStatus: String
  },
  data() {
    return {
      pages: [],
      errors: [],
      messages: [],
    }
  },
  mounted() {
    this.getSplashPages();
    this.$root.$on("delete_page", (page) => {
      this.deletePage(page);
    });
    this.$root.$on("page_created", () => {
      this.getSplashPages();
    });
    this.$root.$on("publish_page", (page) => {
      this.publishPage(page);
    });
  },

  watch: {
    errors: function (errors) {
      this.$root.$emit('alert_error', errors);
    },
    messages: function (messages) {
      this.$root.$emit('alert_success', messages);
    }
  },
  methods: {
    getSplashPages() {
      SplashPageService.getAll("organization_id=" + this.$store.getters.orgId)
          .then(response => {
            this.pages = response.pages;
          });
    },
    deletePage(page) {
      SplashPageService.deletePage(page.id)
          .then(response => {
            if (response != null) {
              this.$root.$emit("alert_success", [response])
              this.getSplashPages();
            }
          });
    },
    publishPage(page) {
      SplashPageService.publishPage(page.id)
          .then(response => {
            if (response.page != null) {
              this.$root.$emit("alert_success", [response.message])
              this.getSplashPages();
            }
          });
    }
  }
}
</script>

<style scoped>

</style>